/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_KcalInputs */

const en_planner_kcal = /** @type {(inputs: Planner_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kcal per person and day (optional)`)
};

const de_planner_kcal = /** @type {(inputs: Planner_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kcal pro Person und Tag (optional)`)
};

/**
* | output |
* | --- |
* | "kcal per person and day (optional)" |
*
* @param {Planner_KcalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_kcal = /** @type {((inputs?: Planner_KcalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_KcalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_kcal(inputs)
	return en_planner_kcal(inputs)
});